import type { JSX } from "react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export interface EnumValuesEditorProps {
  value: string[];
  onChange: (next: string[]) => void;
}

export function EnumValuesEditor({
  value,
  onChange,
}: EnumValuesEditorProps): JSX.Element {
  const updateValue = (index: number, nextValue: string) => {
    onChange(
      value.map((currentValue, currentIndex) =>
        currentIndex === index ? nextValue : currentValue,
      ),
    );
  };

  const removeValue = (index: number) => {
    onChange(value.filter((_, currentIndex) => currentIndex !== index));
  };

  return (
    <div className="space-y-2">
      <Label>Enum values</Label>
      {value.map((enumValue, index) => (
        <div className="flex gap-2" key={index}>
          <Input
            aria-label={`Enum value ${index + 1}`}
            value={enumValue}
            onChange={(event) => updateValue(index, event.target.value)}
          />
          <Button
            type="button"
            variant="ghost"
            size="sm"
            aria-label={`Remove enum value ${index + 1}`}
            onClick={() => removeValue(index)}
          >
            Remove
          </Button>
        </div>
      ))}
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => onChange([...value, ""])}
      >
        Add value
      </Button>
    </div>
  );
}
